






module.exports =
  name: 'bulk_update'
  props: ['selected']
  data: ->
    loading: false
  methods:
    confirmDelete: ->
      promise = @$confirm @$t('confirm_deletion'), '⚠️',
        confirmButtonText: @$t('do_delete')
        cancelButtonText: @$t('do_not_delete')
        type: 'error'
      promise.then @destroySelected
      promise.catch -> true
    destroySelected: ->
      HM.track 'transaction-bulk_destroy'
      @loading = true
      params =
        transaction_ids: _.map(@selected, 'id')
      HM_API.bulk_destroy_transactions(params).then =>
        @$store.commit '💾 TRANSACTIONS/BULK_DESTROY', params.transaction_ids
        @$message
          type: 'success'
          message: @$t('Done')
        @loading = false

    confirmChangeCategory: ->
      promise = @$prompt @$t('New category'), @$t('Update Category'),
        confirmButtonText: @$t('Save'),
        cancelButtonText: @$t('Cancel')
      promise.then (new_category) =>
        HM.track 'transaction-bulk_update_category'
        params =
          transaction_ids: _.map(@selected, 'id')
          new_category: (new_category.value || '').trim()
        @loading = true
        HM_API.bulk_update_transactions(params).then =>
          for tr in _.clone(@selected)
            tr.category = params.new_category
          @$message
            type: 'success'
            message: @$t('Done')
          @loading = false

